export const PT_ORDERS = "/order";
export const PT_VIEWINVOICE = "/viewinvoice/:frmPage/:orderID";

export const ORDER_STACK_PATHS_CONTAIN_CHECK = (pathname) => {
  let firstPart = pathname.split("/").filter(Boolean)[0];
  let paths = PT_VIEWINVOICE + PT_ORDERS;
  return paths.toUpperCase().includes(firstPart.toUpperCase());
};
